exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icons-container[data-v-d1f35ad4]{margin:10px 20px 0;overflow:hidden}.icons-container .grid[data-v-d1f35ad4]{position:relative;display:grid;grid-template-columns:repeat(auto-fill, minmax(120px, 1fr))}.icons-container .icon-item[data-v-d1f35ad4]{margin:10px 20px;text-align:center;width:100px;float:left;font-size:30px;color:#24292e;cursor:pointer}.icons-container span[data-v-d1f35ad4]{display:block;font-size:16px;margin-top:10px}.icons-container .disabled[data-v-d1f35ad4]{pointer-events:none}\n", ""]);

// exports
